// extracted by mini-css-extract-plugin
module.exports = {"root":"RippleButton_root__2H67Z","defaultBtn":"RippleButton_defaultBtn__2dpJW","ripple":"RippleButton_ripple__1nSBL"};